import * as cx from 'classnames';
import { BooleanPair } from 'mk2/apps/strollers/features/other';
import * as React from 'react';
import styles from './BooleanMark.mscss';

interface OwnProps {
    booleanPair: BooleanPair;
    className?: string;
}

const Text = (props) => {
    const { text } = props;
    return text ? (
        <span className={styles.BooleanMark__text}> {text}</span>
    ) : null;
};

const Yes = (props) => {
    const { className, text } = props;
    return (
        <span className={cx(styles.BooleanMark__mark, className)}>
            <i className={cx(styles['BooleanMark__mark--yes'], 'fa', 'fa-check')} />
            <Text text={text} />
        </span>
    );
};

const No = (props) => {
    const { className } = props;
    return (
        <i className={cx(styles.BooleanMark__mark, className, styles['BooleanMark__mark--no'], 'fa', 'fa-times')} />
    );
};

export class BooleanMark extends React.Component<OwnProps> {
    public render() {
        const [ boolValue, text ] = this.props.booleanPair;
        const Mark = boolValue ? Yes : No;
        return (
            <Mark className={this.props.className} text={text} />
        );
    }
}
